/* import __COLOCATED_TEMPLATE__ from './address-input-field-postal-old.hbs.js'; */
var _dec, _class;
import { tagName } from '@ember-decorators/component';
import AddressInputFieldPostal from './address-input-field-postal';
let AddressInputFieldPostalOld = (_dec = tagName(''), _dec(_class = class AddressInputFieldPostalOld extends AddressInputFieldPostal {}) || _class);
export { AddressInputFieldPostalOld as default };